import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

import { APP_COMPONENT_SELECTOR } from './app.component';

@Injectable({
  providedIn: 'root'
})
export class AppDomContextService {
  private cachedElement?: Element;

  public constructor(@Inject(DOCUMENT) private readonly document: Document) {}

  public get element(): Element {
    if (!this.cachedElement) {
      const el = this.document.querySelector(APP_COMPONENT_SELECTOR);
      if (!el) {
        throw new Error(`could not find an element for APP_COMPONENT_SELECTOR '${APP_COMPONENT_SELECTOR}'`);
      }
      this.cachedElement = el;
    }
    return this.cachedElement;
  }

  public get shadowRoot(): ShadowRoot | Document {
    const { element } = this;
    return element.tagName?.toLowerCase() === APP_COMPONENT_SELECTOR && element.shadowRoot
      ? element.shadowRoot
      : this.document;
  }
}
